import { IActRevaluationCreateDTO, IActRevaluationFillWithRemnantsOnStoreDto, IActRevaluationFillWithRemnantsOnStoreResponse, IActRevaluationFromSingleStoreResponse, IActRevaluationFromStoreDTO, IActRevaluationFromStoresResponse, IActRevaluationGetDTO, IActRevaluationUpdateDTO, IActRevaluationValidateStoresDto, IActRevaluationValidateStoresResponse, IActRevaluationViewDTO } from "../../coreapi-dto/documents/ActRevaluation";
import { IActRevaluationItemGetDTO, IActRevaluationItemViewDTO } from "../../coreapi-dto/documents/ActRevaluationItem";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDocRequestV2 } from "./baseDocRequestV2";

export class ActRevaluationRequest extends BaseDocRequestV2<IActRevaluationViewDTO, IActRevaluationGetDTO, IActRevaluationCreateDTO, IActRevaluationUpdateDTO, IActRevaluationItemViewDTO, IActRevaluationItemGetDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "ActRevaluation", token, eventHandler)
    }

    create(body: IActRevaluationCreateDTO, callback: (e: CoreApiResponse<string>) => void) {
        super.create(body, callback)
    }

    update(idGlobal: string, body: IActRevaluationUpdateDTO, callback: (e: CoreApiResponse<null>) => void) {
        super.update(idGlobal, body, callback)
    }

    createFromStoreMany(dto: IActRevaluationFromStoreDTO, callback: (e: CoreApiResponse<IActRevaluationFromStoresResponse>) => void, failedCallback?: (e) => void) {
        this.post<IActRevaluationFromStoresResponse>(`${this._baseUrl}/${this._routePrefix}/FromStoreMany`, dto, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    failedCallback?.(e);
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        });
    }
    createFromStore(
        idStoreGlobal: string,
        lotsLimitPerDocumentNo: number = 150,
        remnantsType: string = "VatSourceOnly",
        calculateWithPricingModel: boolean = true,
        generateNewBarcodes: boolean = false,
        idPricingModel: string | null = null,
        callback: (e: CoreApiResponse<IActRevaluationFromSingleStoreResponse>) => void,
        failedCallback?: (e) => void
    ) {
        const queryParams = new URLSearchParams({
            lotsLimitPerDocumentNo: lotsLimitPerDocumentNo.toString(),
            remnantsType: remnantsType,
            calculateWithPricingModel: calculateWithPricingModel ? 'true' : 'false',
            generateNewBarcodes: generateNewBarcodes ? 'true' : 'false'
        });

        // Добавляем idPricingModel только если он не null и не undefined
        if (idPricingModel) {
            queryParams.append('idPricingModel', idPricingModel);
        }

        const url = `${this._baseUrl}/${this._routePrefix}/FromStore/${idStoreGlobal}?${queryParams}`;

        this.post<IActRevaluationFromSingleStoreResponse>(
            url,
            null,
            this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
            (e) => {
                if (this._eventHandler) {
                    if (e.respType === "isFailed") {
                        failedCallback?.(e);
                        this._eventHandler.onGetResponse(e);
                    }
                }
                callback?.(e);
            }
        );
    }

    validateStores(dto: IActRevaluationValidateStoresDto, callback: (e: CoreApiResponse<IActRevaluationValidateStoresResponse>) => void, failedCallback?: (e) => void) {
        this.post<IActRevaluationValidateStoresResponse>(`${this._baseUrl}/${this._routePrefix}/ValidateStores`, dto, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    failedCallback?.(e);
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        });
    }

    fillWithRemnantsOnStore(
        idDocumentGlobal: string,
        dto: IActRevaluationFillWithRemnantsOnStoreDto,
        callback: (e: CoreApiResponse<IActRevaluationFillWithRemnantsOnStoreResponse | null>) => void,
        failedCallback?: (e) => void
    ) {

        const url = `${this._baseUrl}/${this._routePrefix}/${idDocumentGlobal}/FillWithRemnantsOnStore`;

        this.put2<IActRevaluationFillWithRemnantsOnStoreResponse>(
            url,
            dto,
            this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
            (e) => {
                if (this._eventHandler) {
                    if (e.respType === "isFailed") {
                        failedCallback?.(e);
                        this._eventHandler.onGetResponse(e);
                    }
                }
                callback?.(e);
            }
        );
    }

    deleteReserves(
        idDocumentGlobal: string,
        callback: (e: any) => void,
        failedCallback?: (e: any) => void
    ) {
        const url = `${this._baseUrl}/${this._routePrefix}/${idDocumentGlobal}/Reserves/`;

        this.delete(
            url,
            null,
            this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
            (e) => {
                if (this._eventHandler) {
                    if (e.respType === "isFailed") {
                        failedCallback?.(e);
                        this._eventHandler.onGetResponse(e);
                    }
                }
                callback?.(e);
            }
        );
    }
}